module.exports = __webpack_public_path__ + "img/cloud-moon-rain.cf76f52c.svg";